import displayNameByPlatformKey from "@/terminal/research/recipes/platform-display-names.generated.json"

// Each Source Platform's display name, from the recipe registry and the
// proofs' abstract platforms. `pnpm recipes:generate` writes this small table
// beside the registry, so a page that shows names loads no registry.
const displayNames: Record<string, string> = displayNameByPlatformKey

export const hasSourcePlatform = (platformKey: string) =>
  Object.hasOwn(displayNames, platformKey)

export const sourcePlatformDisplayName = (platformKey: string) =>
  displayNames[platformKey] ?? platformKey
